import React from 'react';
import { Box, IconButton } from '@mui/material';

/**
 * Star rating display + optional edit mode.
 *   <Stars value={4} />                 // read-only
 *   <Stars value={form.rating} onChange={setRating} size={22} />  // editable
 */
export default function Stars({ value, onChange, size = 16, color = '#f59e0b' }) {
  const v = Number(value || 0);
  if (!onChange) {
    return (
      <Box component='span' sx={{ color, fontSize: size, lineHeight: 1 }}>
        {[1, 2, 3, 4, 5].map((n) => (
          <span key={n}>{n <= v ? '★' : '☆'}</span>
        ))}
      </Box>
    );
  }
  return (
    <Box sx={{ display: 'inline-flex', gap: '2px' }}>
      {[1, 2, 3, 4, 5].map((n) => (
        <IconButton
          key={n}
          size='small'
          aria-label={`${n} star${n > 1 ? 's' : ''}`}
          onClick={() => onChange(n)}
          sx={{ p: '2px', color: n <= v ? color : 'action.disabled', fontSize: size }}
        >
          <Box component='span' sx={{ fontSize: size, lineHeight: 1 }}>
            {n <= v ? '★' : '☆'}
          </Box>
        </IconButton>
      ))}
    </Box>
  );
}
